module.exports = __webpack_public_path__ + "img/brand1.bc6a0381.png";